import { Injectable } from '@angular/core';
import { CityBorough } from '@models/city-borough.model';
import BaseService from './base.service';

@Injectable({
  providedIn: 'root'
})
export class CityBoroughService extends BaseService<CityBorough> {}
